const NotificationsIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.84521 14C6.96224 14.2027 7.13056 14.371 7.33324 14.488C7.53593 14.605 7.76584 14.6666 7.99988 14.6666C8.23392 14.6666 8.46383 14.605 8.66652 14.488C8.8692 14.371 9.03752 14.2027 9.15455 14"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.17467 10.2199C2.08758 10.3154 2.0301 10.4341 2.00924 10.5616C1.98837 10.6891 2.00501 10.82 2.05714 10.9382C2.10926 11.0564 2.19462 11.157 2.30284 11.2276C2.41105 11.2982 2.53745 11.3358 2.66667 11.3359H13.3333C13.4625 11.336 13.589 11.2985 13.6972 11.228C13.8055 11.1575 13.891 11.0571 13.9433 10.9389C13.9955 10.8208 14.0123 10.69 13.9916 10.5625C13.9709 10.4349 13.9136 10.3162 13.8267 10.2206C12.94 9.3066 12 8.33527 12 5.33594C12 4.27507 11.5786 3.25766 10.8284 2.50751C10.0783 1.75736 9.06087 1.33594 8 1.33594C6.93914 1.33594 5.92172 1.75736 5.17157 2.50751C4.42143 3.25766 4 4.27507 4 5.33594C4 8.33527 3.05933 9.3066 2.17467 10.2199Z"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NotificationsIcon;
